<template>
<div>
    <div class="mx-n3 mb-3">
        <legend class="font-weight-semibold h5 px-3">
            <i class="fa-solid fa-shield-check mr-2"></i>{{ $t("Account Deletion Terms and Conditions") }}
        </legend>
    </div>

    <div class="card">
        <div class="card-body">
            <div class="mb-2">
                {{ $t('Dear Gosaas customer, you may delete your account any time, but after the deletion is processed, everything in your account will be deleted forever and may not be recovered. Therefore, before deleting your account, please understand the following:') }}
            </div>
            <ol class="pl-3">
                <li class="mb-2">
                    <h6 class="mb-1">{{ $t('What does it mean to delete an account') }}</h6>
                    <div>{{ $t('You will lose all data and content in your account, including communication records, files, and images.') }}</div>
                    <div>{{ $t('Account will not be recoverable once deleted.') }}</div>
                </li>
                <li class="mb-2">
                    <h6 class="mb-1">{{ $t('View or save your information') }}</h6>
                    <div>{{ $t('View the information in your account, confirm if the information in your account can be deleted forever.') }}</div>
                </li>
            </ol>
            <div>{{ $t("If you read and agree to Gosaas's account deletion description, Please")}} <b> “{{$t("Agree")}}” </b> {{$t("to proceed with the next step.") }}</div>
        </div>
    </div>
    <div class="form-check mb-3">
        <label class="form-check-label">
            <div :class="['uniform-checker' , $parent.isAgree ? 'border-primary text-primary':'']">
                <span :class="[ $parent.isAgree ? 'checked':'']" @click="$parent.isAgree = !$parent.isAgree">
                    <input type="checkbox" class="form-check-input-styled-primary" :checked="$parent.isAgree" data-fouc="">
                </span>
            </div>
            {{ $t('I have read and agree to these terms and conditions') }}
        </label>
    </div>

</div>
</template>

<script>
export default {
    components: {},
    data() {
        let vm = this;
        return {
            
        };

    },
    methods: {

    },

};
</script>



// WEBPACK FOOTER //
// src/components/central/account/security/AccountDeletionInfo.vue